import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Necesito la versión de pago de ChatGPT?',
  a: 'No, el método funciona con cualquier modelo (GPT-4, Claude, Gemini o versiones gratuitas).'
}, {
  q: '¿Es difícil de aprender?',
  a: 'Si sabes escribir una frase, sabes usar el método C-R-T-R.'
}, {
  q: '¿Sirve para otros idiomas?',
  a: 'Sí, el razonamiento estructural es universal.'
}, {
  q: '¿Tengo que saber de tecnología?',
  a: 'Cero. Es un manual de comunicación, no de informática.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-navy-800/30 border-t border-white/5" data-id="element-23">
      <div className="max-w-3xl mx-auto" data-id="element-24">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-25">
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-26">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-27">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="glass-card rounded-xl overflow-hidden" data-id="element-28">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-29">
                <span className="text-lg font-semibold text-white" data-id="element-30">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-cyan-accent transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-31" />
              </button>
              <AnimatePresence data-id="element-32">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-33">
                    <div className="px-6 pb-5 text-gray-400" data-id="element-34">{faq.a}</div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}